import ajax from '@/plugin/ajax'


const fileIcons = {
    'png': 'icon-filetype-image',
    'jpg': 'icon-filetype-image',
    'jpeg': 'icon-filetype-image',
    'gif': 'icon-filetype-image',
    'bmp': 'icon-filetype-image',
    'svg': 'icon-filetype-image',
    'pdf': 'icon-filetype-pdf',
    'mp3': 'icon-filetype-audio',
    'aac': 'icon-filetype-audio',
    'wav': 'icon-filetype-audio',
    'ppt': 'icon-filetype-ppt',
    'psd': 'icon-filetype-psd',
    'txt': 'icon-filetype-txt',
    'mp4': 'icon-filetype-video',
    'rmvb': 'icon-filetype-video',
    'mov': 'icon-filetype-video',
    'flv': 'icon-filetype-video',
    'avi': 'icon-filetype-video',
    'doc': 'icon-filetype-word',
    'docx': 'icon-filetype-word',
    'dotx': 'icon-filetype-word',
    'xls': 'icon-filetype-excel',
    'xlsx': 'icon-filetype-excel',
    'zip': 'icon-filetype-reduce',
    'tar': 'icon-filetype-reduce',
    'gz': 'icon-filetype-reduce',
    'rar': 'icon-filetype-reduce'
}

const getFileIcon = function (filename) {
    if(!filename) return 'icon-filetype-unknow'
    let ext = filename.substring(filename.lastIndexOf('.') + 1)
    return fileIcons[ext] || 'icon-filetype-unknow'
}

const deleteAttach = function (file, mailId) {
    if (!file.success && !file.s3Id && !mailId) return
    let query = {}
    if(mailId) {
        query.id = file.s3Id
        query.mailId = mailId
    } else {
        query.id = JSON.parse(file.response).data.id
    }
    return new Promise((resovle, reject) => {
        ajax.delete('/vipapi/attach', {
            data: query
        }).then(res => {
            if (res.status === 200) {
                resovle(true)
            } else {
                reject()
            }
        })
    })
}

const getAttachToken = function () {
    return new Promise((resovle, reject) => {
        ajax.get('/vipapi/attach/token').then(res => {
            if (res.status === 200) {
                resovle(res.data.token)
            } else {
                reject(res.status)
            }
        })
    })
}
const getToken = function(option){
    return ajax.get("/vipapi/attach/token",{
        params:option
    })
}

const getMailAddr = function (mails) {
    let mailAddr = []
    mails.forEach(mail => {
        if (!/<.*>/.test(mail.addr)) {
            mail.addr = `<${mail.addr}>`
        }
        mailAddr.push(mail.addr)
    })
    return mailAddr
}

const sendMail = function (data) {
    return new Promise((resovle, reject) => {
        ajax.put('/vipapi/mail', data).then(res => {
            if (res.status === 200) {
                resovle(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

const getMailById = function (id) {
    return new Promise((resovle, reject) => {
        ajax.get(`/vipapi/getMail?id=${id}`).then(res => {
            if(res.status === 200) {
                resovle(res.data)
            } else {
                reject(res.status)
            }
        })
    })
}

export {
    getAttachToken,
    getFileIcon,
    deleteAttach,
    sendMail,
    getMailAddr,
    getMailById,
    getToken
}



// WEBPACK FOOTER //
// ./src/service/writeService.js